// Lib
import React from 'react';
import { Typography, Box } from '@mui/material';

// Components
import IconButton from '../../../Button/IconButton/IconButton';
import EditRequestButton from '../../../Button/EditRequestButton';
import Feather from '../../../Feather';

// Hooks
import useUI from '../../../../hooks/useUI';
import useCart from '../../../../pages/Cart/hooks/useCart';
import useRequest from '../../../../pages/Cart/hooks/useRequest';

// Styles
import { useStyles } from './CartBarStyles';

const CartBar = ({ countInCart }) => {
  const { isTabletMode, isSmallMobileMode } = useUI();
  const { onDeleteAllProducts } = useCart();
  const { classes } = useStyles();
  const { openRequestCard, savedRequest, isRequestRequired } = useRequest(
    null,
    true,
  );

  return (
    <div className={classes.root}>
      {isTabletMode && (
        <Typography alignSelf="start" variant="h2" className={classes.title}>
          Cart<span className={classes.muted}>({countInCart})</span>
        </Typography>
      )}
      {!!countInCart && (
        <>
          <div className={classes.buttonContainer}>
            <Typography variant="h3">{`Total Items: ${countInCart}`}</Typography>
            <Box display="flex" gap={4}>
              {!isSmallMobileMode && savedRequest && isRequestRequired && (
                <EditRequestButton
                  onClick={openRequestCard}
                  title="Edit Qty Request"
                />
              )}
              <IconButton
                onClick={onDeleteAllProducts}
                startIcon={<Feather type="delete" />}
                data-testid="cart-remove-all-button">
                Remove All
              </IconButton>
            </Box>
          </div>
          {isSmallMobileMode && savedRequest && isRequestRequired && (
            <EditRequestButton
              onClick={openRequestCard}
              title="Edit Qty Request"
            />
          )}
        </>
      )}
    </div>
  );
};

export default CartBar;
